/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Label,
  FormGroup,
  Row,
  Col,
  Input,
  Container,
  CardHeader,
  Button,
  Form,
  CardFooter, FormFeedback
} from "reactstrap";
import { useHistory } from "react-router-dom";
import SimpleHeader from "components/Headers/SimpleHeader.js";
import Select from 'react-select';
import axios from 'axios';
import moment from 'moment';

export default function EditProject(props) {
  const token = localStorage.getItem("token");
  const [isLoading, setLoading] = useState(false);
  let history = useHistory();
  const [bentukMerchant, setBentuMerchant] = useState(1);
  const [isSelectedStatus, setSelectedStatus] = useState(1);
  const [brand, setBrand] = useState("");
  const [namaBadanHukum, setNamaBadanHukum] = useState("");
  const [address, setAddress] = useState("");
  const [countryId, setCountryId] = useState("");
  const [countries, setCountries] = useState([]);
  const [regionId, setRegionId] = useState(null);
  const [regions, setRegions] = useState([]);
  const [regancy, setRegancy] = useState(null);
  const [regencies, setRegencies] = useState([]);
  const [district, setDistrict] = useState(null);
  const [districts, setDistricts] = useState([]);
  const [kodePos, setKodePos] = useState("");
  const [dateSewa, setDataSewa] = useState("");
  const [jamOprasionalA, setJamOprasionalA] = useState("");
  const [jamOprasionalB, setJamOprasionalB] = useState("");
  const [omzet, setOmzet] = useState("");
  const [jenisLangganan, setJenisLangganan] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [categories, setCategories] = useState([]);

  const [nama, setNama] = useState("");
  const [tempatLahir, setTempatLahir] = useState("");
  const [tanggalLahir, setTanggalLahir] = useState("");
  const [nomorTelpon, setNomorTelpon] = useState("");
  const [email, setEmail] = useState("");

  const [namaBank, setNamaBank] = useState("");
  const [nomorBank, setNomorBank] = useState("");
  const [pemilikRekening, setPemilikRekening] = useState("");
  const [cabang, setCabang] = useState("");

  const [ktp, setKtp] = useState(false);
  const [npwp, setNpwp] = useState(false);
  const [pbb, setPbb] = useState(false);
  const [fotoUsaha, setFotoUsaha] = useState(false);

  const [aktaPerusahaan, setAktaPerusahaan] = useState(false);
  const [suratKemenkumham, setSuratKemenkumham] = useState(false);
  const [siup, setSiup] = useState(false);
  const [tdp, setTdp] = useState(false);
  const [situ, setSitu] = useState(false);
  const [suratKuasa, setSuratKuasaa] = useState(false);

  const [tanggalDoc, setTanggalDoc] = useState("");
  const [status, setStatus] = useState("");
  const [statusList, setStatusList] = useState([]);

  const [isCheckedIn] = useState(false);

  const [addressError, setAddressError] = useState(null);
  const [kodePosError, setKodePosError] = useState(null);
  const [dateSewaError, setDataSewaError] = useState(null);
  const [omzetError, setOmzetError] = useState(null);
  const [jenisLanggananError, setJenisLanggananError] = useState(null);
  const [namaError, setNamaError] = useState(null);
  const [tempatLahirError, setTempatLahirError] = useState(null);
  const [tanggalLahirError, setTanggalLahirError] = useState(null);
  const [nomorTelponError, setNomorTelponError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [namaBankError, setNamaBankError] = useState(null);
  const [nomorBankError, setNomorBankError] = useState(null);
  const [pemilikRekeningError, setPemilikRekeningError] = useState(null);
  const [cabangError, setCabangError] = useState(null);
  const [tanggalDocError, setTanggalDocError] = useState(null);

  const validateForm = () => {
    let error = false;
    if (address === "") {
      setAddressError("invalid");
      error = true;
    }
    if (kodePos === "") {
      setKodePosError("invalid");
      error = true;
    }
    if (isSelectedStatus === 2) {
      if (dateSewa === "") {
        setDataSewaError("invalid");
        error = true;
      }
    }
    if (omzet === "") {
      setOmzetError("invalid");
      error = true;
    }
    if (jenisLangganan === "") {
      setJenisLanggananError("invalid");
      error = true;
    }
    if (nama === "") {
      setNamaError("invalid");
      error = true;
    }
    if (tempatLahir === "") {
      setTempatLahirError("invalid");
      error = true;
    }
    if (tanggalLahir === "") {
      setTanggalLahirError("invalid");
      error = true;
    }
    if (nomorTelpon === "") {
      setNomorTelponError("invalid");
      error = true;
    }
    if (email === "") {
      setEmailError("invalid");
      error = true;
    }
    if (namaBank === "") {
      setNamaBankError("invalid");
      error = true;
    }
    if (nomorBank === "") {
      setNomorBankError("invalid");
      error = true;
    }
    if (pemilikRekening === "") {
      setPemilikRekeningError("invalid");
      error = true;
    }
    if (cabang === "") {
      setCabangError("invalid");
      error = true;
    }
    if (tanggalDoc === "") {
      setTanggalDocError("invalid");
      error = true;
    }
    return error;
  };

  useEffect(() => {
    getMerchantById();
    getStatus();
  }, []);

  const getMerchantById = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/merchant/${props.match.params.id}`, {
        method: 'GET', // or 'PUT'
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(),
      })
      const data = await response.json();
      setBentuMerchant(data.response_data.entity_type);
      setBrand(data.response_data.merchant_name);
      setNamaBadanHukum(data.response_data.corporation_name);
      setAddress(data.response_data.merchant_address);
      setKodePos(data.response_data.zip_code);
      setJamOprasionalA(moment(data.response_data.operational_hour_start, 'HH:mm:ss').format("HH:mm:ss"));
      setJamOprasionalB(moment(data.response_data.operational_hour_end, 'HH:mm:ss').format("HH:mm:ss"));
      setOmzet(data.response_data.turnover);
      setJenisLangganan(data.response_data.subscribe_type);
      setCategoryId(data.response_data.merchant_category_id);
      getCountries(data.response_data.country_id);
      getRegions(data.response_data.country_id, data.response_data.region_id);
      getRegencies(data.response_data.region_id, data.response_data.regency_id);
      getDistricts(data.response_data.regency_id, data.response_data.district_id);
      setSelectedStatus(data.response_data.location_status);
      setDataSewa(moment(data.response_data.location_end_period, "DD/MM/YYYY").format("YYYY-MM-DD"));

      setNama(data.response_data.pic_name);
      setTempatLahir(data.response_data.pic_birth_place);
      setTanggalLahir(moment(data.response_data.pic_dob, "DD/MM/YYYY").format("YYYY-MM-DD"));
      setNomorTelpon(data.response_data.pic_phone);
      setEmail(data.response_data.pic_email);

      setNamaBank(data.response_data.bank_name);
      setNomorBank(data.response_data.account_number);
      setPemilikRekening(data.response_data.account_name);
      setCabang(data.response_data.bank_branch);
      setTanggalDoc(moment(data.response_data.doc_collected_date, "DD/MM/YYYY").format("YYYY-MM-DD"));

      setKtp(data.response_data.identity_copy);
      setNpwp(data.response_data.tax_copy);
      setPbb(data.response_data.property_tax_copy);
      setFotoUsaha(data.response_data.pob_picture);

      setAktaPerusahaan(data.response_data.company_deed_copy);
      setSuratKemenkumham(data.response_data.gov_letter_copy);
      setSiup(data.response_data.trade_licence_copy);
      setTdp(data.response_data.crc_copy);
      setSitu(data.response_data.pob_permit_copy);
      setSuratKuasaa(data.response_data.power_of_attorney);

      setStatus(data.response_data.merchant_status);

      getMerchantCategoryById(data.response_data.merchant_category_id);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const getMerchantCategoryById = async (merchant_category_id) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/merchantCategories/${merchant_category_id}`, {
        method: 'GET', // or 'PUT'
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(),
      })
      const data = await response.json();
      const responseData = data.response_data;
      setCategoryId(data.response_data.merchant_category_id);
      getCategories(responseData.merchant_category_name, merchant_category_id);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const getCategories = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/merchantCategories/list`, {
        method: 'GET', // or 'PUT'
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(),
      })
      const data = await response.json();
      setCategories(data.response_data);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const getCountries = async (country_id) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/countries`, {
        method: 'GET', // or 'PUT'
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(),
      })
      const data = await response.json();
      let options = [];
      data.response_data.map((country) => {
        if (country.country_id === country_id)
          setCountryId({ value: country.country_id, label: country.name });
        return options.push({ value: country.country_id, label: country.name })

      })
      setCountries(options);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const getRegions = async (country_id, region_id) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/regions?country_id=${country_id}`, {
        method: 'GET', // or 'PUT'
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(),
      })
      const data = await response.json();
      let options = [];
      data.response_data.map((region) => {
        if (region.region_id === region_id)
          setRegionId({ value: region.region_id, label: region.name });
        return options.push({ value: region.region_id, label: region.name })
      })
      setRegions(options);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const getRegencies = async (region_id, regency_id) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/regencies?region_id=${region_id}`, {
        method: 'GET', // or 'PUT'
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(),
      })
      const data = await response.json();
      let options = [];
      data.response_data.map((city) => {
        if (city.regency_id === regency_id)
          setRegancy({ value: city.regency_id, label: city.name });
        return options.push({ value: city.regency_id, label: city.name })
      })
      setRegencies(options);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const getDistricts = async (regency_id, district_id) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/districts?regency_id=${regency_id}`, {
        method: 'GET', // or 'PUT'
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(),
      })
      const data = await response.json();
      let options = [];
      data.response_data.map((district) => {
        if (district.district_id === district_id)
          setDistrict({ value: district.district_id, label: district.name });
        return options.push({ value: district.district_id, label: district.name })
      })
      setDistricts(options);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const handleSelectedItem = (element) => {
    setCountryId(element);
    getRegions(element.value);
  }

  const handleSelectedRegion = (element) => {
    setRegionId(element);
    getRegencies(element.value);
  }

  const handleSelectedRegancy = (element) => {
    setRegancy(element);
    getDistricts(element.value);
  }

  const handleSelectedDistrict = (element) => {
    setDistrict(element);
  }

  const getStatus = () => {
    const data = { type: "merchant" }
    fetch(`${process.env.REACT_APP_API_BASE_URL}/status`, {
      method: 'POST', // or 'PUT'
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => {
        setStatusList(data.response_data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  function updateData() {
    setLoading(true);
    let body = {
      entity_type: parseInt(bentukMerchant),
      merchant_name: brand,
      corporation_name: namaBadanHukum,
      merchant_address: address,
      country_id: parseInt(countryId.value),
      region_id: parseInt(regionId.value),
      regency_id: parseInt(regancy.value),
      district_id: parseInt(district.value),
      zip_code: kodePos,
      turnover: omzet,
      location_status: parseInt(isSelectedStatus),
      location_end_period: dateSewa === "Invalid date" ? "" : moment(dateSewa).format("DD/MM/YYYY"),
      merchant_category_id: parseInt(categoryId),
      operational_hour_start: jamOprasionalA === "Invalid date" ? "" : moment(jamOprasionalA, 'HH:mm:ss').format("HH:mm:ss"),
      operational_hour_end: jamOprasionalB === "Invalid date" ? "" : moment(jamOprasionalB, 'HH:mm:ss').format("HH:mm:ss"),
      subscribe_type: parseInt(jenisLangganan),
      pic_name: nama,
      pic_birthplace: tempatLahir,
      pic_dob: moment(tanggalLahir).format("DD/MM/yyyy"),
      pic_phone: nomorTelpon,
      pic_email: email,
      bank_name: namaBank,
      account_number: nomorBank,
      account_name: pemilikRekening,
      bank_branch: cabang,
      identity_copy: parseInt(ktp),
      tax_copy: parseInt(npwp),
      property_tax_copy: parseInt(pbb),
      pob_picture: parseInt(fotoUsaha),
      doc_collected_date: moment(tanggalDoc).format("DD/MM/yyyy"),

      company_deed_copy: parseInt(aktaPerusahaan),
      gov_letter_copy: parseInt(suratKemenkumham),
      trade_licence_copy: parseInt(siup),
      crc_copy: parseInt(tdp),
      pob_permit_copy: parseInt(situ),
      power_of_attorney: parseInt(suratKuasa),
      merchant_status: parseInt(status),
    }
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/project/update/${props.match.params.id}`, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then(function (response) {
        history.push("/admin/customers/daftar-project");
      })
      .then(json => {
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      updateData();
    }
  }

  return (
    <>
      <SimpleHeader name="Edit Project" parentName="Customers" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Form onSubmit={handleSubmit}>
              <Card>
                <CardHeader>
                  <h3>Edit Project</h3>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <Label
                          className="form-control-label"
                          htmlFor="exampleFormControlSelect3"
                        >
                          Bentuk Merchant
                                    </Label>
                        <Row>
                          <Col>
                            <div style={{ display: "flex" }}>
                              <div className="custom-control custom-radio mb-3">
                                <Input
                                  className="custom-control-input"
                                  defaultChecked
                                  disabled={true}
                                  id="customRadio5"
                                  name="custom-radio-2"
                                  type="radio"
                                  value={1}
                                  checked={bentukMerchant === 1}
                                  onClick={() => setBentuMerchant(1)}
                                />
                                <Label
                                  className="custom-control-label"
                                  htmlFor="customRadio5"
                                >
                                  Perorangan
                                                    </Label>
                              </div>
                              <div className="custom-control custom-radio mb-3" style={{ marginLeft: "20px" }}>
                                <Input
                                  className="custom-control-input"
                                  disabled={true}
                                  id="customRadio6"
                                  name="custom-radio-2"
                                  type="radio"
                                  value={2}
                                  checked={bentukMerchant === 2}
                                  onClick={() => setBentuMerchant(2)}
                                />
                                <Label
                                  className="custom-control-label"
                                  htmlFor="customRadio6"
                                >
                                  Badan Hukum
                                                    </Label>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="exampleFormControlInput1"
                    >
                      Nama / Brand
                    </Label>
                    <Input
                      type="text"
                      placeholder="Masukan Nama / Brand"
                      value={brand}
                      disabled
                      onChange={e => setBrand(e.target.value)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="exampleFormControlInput1"
                    >
                      Nama Badan Hukum
                            </Label>
                    <Input
                      type="text"
                      placeholder="Masukan Nama Badan Hukum"
                      value={namaBadanHukum}
                      disabled
                      onChange={e => setNamaBadanHukum(e.target.value)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="exampleFormControlInput1"
                    >
                      Alamat
                            </Label>
                    <Input
                      type="textarea"
                      placeholder="Masukan Alamat"
                      value={address}
                      invalid={addressError === "invalid"}
                      onChange={(e) => {
                        setAddress(e.target.value);
                        if (e.target.value !== "") {
                          setAddressError("");
                        }
                      }}
                    />
                    <FormFeedback>Alamat tidak boleh kosong</FormFeedback>
                  </FormGroup>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label
                          className="form-control-label"
                          htmlFor="exampleFormControlInput1"
                        >
                          Negara
                                    </Label>
                        <Select
                          className="country-select"
                          classNamePrefix="select"
                          onChange={e => handleSelectedItem(e)}
                          value={countryId}
                          isDisabled={isCheckedIn}
                          options={countries}
                        />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <Label
                          className="form-control-label"
                          htmlFor="exampleFormControlInput1"
                        >
                          Provinsi
                                    </Label>
                        <Select
                          className="region-select"
                          classNamePrefix="select"
                          onChange={e => handleSelectedRegion(e)}
                          value={regionId}
                          isDisabled={isCheckedIn}
                          options={regions}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label
                          className="form-control-label"
                          htmlFor="exampleFormControlInput1"
                        >
                          Kab./Kota
                        </Label>
                        <Select
                          className="regancy-select"
                          classNamePrefix="select"
                          onChange={e => handleSelectedRegancy(e)}
                          value={regancy}
                          isDisabled={isCheckedIn}
                          options={regencies}
                        />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <Label
                          className="form-control-label"
                          htmlFor="exampleFormControlInput1"
                        >
                          Kecamatan
                                    </Label>
                        <Select
                          className="district-select"
                          classNamePrefix="select"
                          onChange={e => handleSelectedDistrict(e)}
                          value={district}
                          isDisabled={isCheckedIn}
                          options={districts}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="exampleFormControlInput1"
                    >
                      Kode Pos
                            </Label>
                    <Input
                      type="number"
                      placeholder="Masukan Kode Pos"
                      value={kodePos}
                      invalid={kodePosError === "invalid"}
                      onChange={(e) => {
                        setKodePos(e.target.value);
                        if (e.target.value !== "") {
                          setKodePosError("");
                        }
                      }}
                    />
                    <FormFeedback>Kode pos tidak boleh kosong</FormFeedback>
                  </FormGroup>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="exampleFormControlSelect3"
                      md="6"
                    >
                      Status Lokasi
                            </Label>
                    <Row>
                      <Col md="6">
                        <div className="custom-control custom-radio mb-3">
                          <Input
                            className="custom-control-input"
                            defaultChecked
                            id="milikSendiri"
                            name="custom-radio-1"
                            type="radio"
                            value={1}
                            checked={isSelectedStatus === 1}
                            onClick={() => setSelectedStatus(1)}
                          />
                          <Label
                            className="custom-control-label"
                            htmlFor="milikSendiri"
                          >
                            Milik Sendiri
                                        </Label>
                        </div>
                        <Row>
                          <Col md="6">
                            <div className="custom-control custom-radio mb-3">
                              <Input
                                className="custom-control-input"
                                id="sewa"
                                name="custom-radio-1"
                                type="radio"
                                value={2}
                                checked={isSelectedStatus === 2}
                                onClick={() => setSelectedStatus(2)}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="sewa"
                              >
                                Sewa
                                                </Label>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      {
                        isSelectedStatus === 1 ? <></> :
                          <Col md="6">
                            <Label
                              className="form-control-label"
                              htmlFor="exampleFormControlSelect3"
                            >
                              Berlaku s/d
                                        </Label>
                            <Input
                              id="example-date-input"
                              type="date"
                              value={dateSewa}
                              invalid={dateSewaError === "invalid"}
                              onChange={(e) => {
                                setDataSewa(e.target.value);
                                if (e.target.value !== "") {
                                  setDataSewaError("");
                                }
                              }}
                            />
                            <FormFeedback>Masa berlaku tidak boleh kosong</FormFeedback>
                          </Col>
                      }
                    </Row>
                  </FormGroup>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="exampleFormControlSelect3"
                    >
                      Kategori
                            </Label>
                    <Input
                      name="kategori"
                      type="select"
                      value={categoryId}
                      disabled
                      onChange={(e) => {
                        setCategoryId(e.target.value);
                      }}>
                      <option value="">Pilih Kategori</option>
                      {
                        categories.map((category, key) => {
                          return <option key={key} value={category.merchant_category_id}>{category.merchant_category_name}</option>
                        })
                      }

                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="example-time-input"
                    >
                      Jam Operasional
                            </Label>
                    <Row>
                      <Col md="6">
                        <Input
                          defaultValue="00:00:00"
                          id="example-time-input"
                          type="time"
                          placeholder="Jam Buka"
                          value={jamOprasionalA}
                          onChange={(e) => {
                            setJamOprasionalA(e.target.value);
                          }}
                        />
                      </Col>
                      <Col md="6">
                        <Input
                          defaultValue="00:00:00"
                          id="example-time-input"
                          type="time"
                          placeholder="Jam Tutup"
                          value={jamOprasionalB}
                          onChange={(e) => {
                            setJamOprasionalB(e.target.value);
                          }}
                        />
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="exampleFormControlInput1"
                    >
                      Omzet
                            </Label>
                    <Input
                      type="text"
                      placeholder="Masukan Omzet"
                      value={omzet}
                      invalid={omzetError === "invalid"}
                      onChange={(e) => {
                        setOmzet(e.target.value);
                        if (e.target.value !== "") {
                          setOmzetError("");
                        }
                      }}
                    />
                    <FormFeedback>Omzet tidak boleh kosong</FormFeedback>
                  </FormGroup>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="jenisLangganan"
                    >
                      Jenis Langganan
                            </Label>
                    <Input
                      id="jenisLangganan"
                      type="select"
                      value={jenisLangganan}
                      invalid={jenisLanggananError === "invalid"}
                      onChange={(e) => {
                        setJenisLangganan(e.target.value);
                        if (e.target.value !== "") {
                          setJenisLanggananError("");
                        }
                      }}
                    >
                      <option value="">Pilih Jenis Langganan</option>
                      <option value={1}>Basic</option>
                      <option value={2}>Menengah</option>
                      <option value={3}>Penuh</option>
                    </Input>
                  </FormGroup>
                </CardBody>
              </Card>
              <Card>
                <CardHeader style={{ borderTop: "20px solid rgba(0, 0, 0, 0.05)" }}>
                  <h3>Data Pemilik / Penanggung Jawab</h3>
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="exampleFormControlInput1"
                    >
                      Nama
                            </Label>
                    <Input
                      type="text"
                      placeholder="Masukan Nama"
                      value={nama}
                      invalid={namaError === "invalid"}
                      onChange={(e) => {
                        setNama(e.target.value);
                        if (e.target.value !== "") {
                          setNamaError("");
                        }
                      }}
                    />
                    <FormFeedback>Nama tidak boleh kosong</FormFeedback>
                  </FormGroup>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="exampleFormControlInput1"
                    >
                      Tempat & Tanggal Lahir
                            </Label>
                    <Row>
                      <Col md="6">
                        <Input
                          type="text"
                          placeholder="Masukan Tempat Lahir"
                          value={tempatLahir}
                          invalid={tempatLahirError === "invalid"}
                          onChange={(e) => {
                            setTempatLahir(e.target.value);
                            if (e.target.value !== "") {
                              setTempatLahirError("");
                            }
                          }}
                        />
                        <FormFeedback>Tempat tidak boleh kosong</FormFeedback>
                      </Col>
                      <Col md="6">
                        <Input
                          id="example-date-input"
                          type="date"
                          value={tanggalLahir}
                          invalid={tanggalLahirError === "invalid"}
                          onChange={(e) => {
                            setTanggalLahir(e.target.value);
                            if (e.target.value !== "") {
                              setTanggalLahirError("");
                            }
                          }}
                        />
                        <FormFeedback>Tanggal lahir tidak boleh kosong</FormFeedback>
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="exampleFormControlInput1"
                    >
                      Nomor Telepon
                            </Label>
                    <Input
                      type="number"
                      placeholder="Masukan No. Telp"
                      value={nomorTelpon}
                      invalid={nomorTelponError === "invalid"}
                      onChange={(e) => {
                        setNomorTelpon(e.target.value);
                        if (e.target.value !== "") {
                          setNomorTelponError("");
                        }
                      }}
                    />
                    <FormFeedback>Nomor Telpon tidak boleh kosong</FormFeedback>
                  </FormGroup>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="exampleFormControlInput1"
                    >
                      Email
                            </Label>
                    <Input
                      type="email"
                      placeholder="Masukan Email"
                      value={email}
                      invalid={emailError === "invalid"}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        if (e.target.value !== "") {
                          setEmailError("");
                        }
                      }}
                    />
                    <FormFeedback>Email tidak boleh kosong</FormFeedback>
                  </FormGroup>
                </CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <h3>Data Rekening</h3>
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="exampleFormControlInput1"
                    >
                      Nama Bank
                            </Label>
                    <Input
                      type="text"
                      placeholder="Masukan Nama Bank"
                      value={namaBank}
                      invalid={namaBankError === "invalid"}
                      onChange={(e) => {
                        setNamaBank(e.target.value);
                        if (e.target.value !== "") {
                          setNamaBankError("");
                        }
                      }}
                    />
                    <FormFeedback>Nama Bank tidak boleh kosong</FormFeedback>
                  </FormGroup>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="exampleFormControlInput1"
                    >
                      Nomor Rekening
                            </Label>
                    <Input
                      type="number"
                      placeholder="Masukan Nomor Rekening"
                      value={nomorBank}
                      invalid={nomorBankError === "invalid"}
                      onChange={(e) => {
                        setNomorBank(e.target.value);
                        if (e.target.value !== "") {
                          setNomorBankError("");
                        }
                      }}
                    />
                    <FormFeedback>Nomor Rekening tidak boleh kosong</FormFeedback>
                  </FormGroup>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="exampleFormControlInput1"
                    >
                      Nama Pemilik Rekening
                            </Label>
                    <Input
                      type="text"
                      placeholder="Masukan Pemilik Rekening"
                      value={pemilikRekening}
                      invalid={pemilikRekeningError === "invalid"}
                      onChange={(e) => {
                        setPemilikRekening(e.target.value);
                        if (e.target.value !== "") {
                          setPemilikRekeningError("");
                        }
                      }}
                    />
                    <FormFeedback>Nama pemilik rekening tidak boleh kosong</FormFeedback>
                  </FormGroup>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="exampleFormControlInput1"
                    >
                      Cabang
                            </Label>
                    <Input
                      type="text"
                      placeholder="Masukan Cabang"
                      value={cabang}
                      invalid={cabangError === "invalid"}
                      onChange={(e) => {
                        setCabang(e.target.value);
                        if (e.target.value !== "") {
                          setCabangError("");
                        }
                      }}
                    />
                    <FormFeedback>Cabang tidak boleh kosong</FormFeedback>
                  </FormGroup>
                </CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <h3>Administrasi Merchant</h3>
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="exampleFormControlSelect3"
                    >
                      Persyaratan
                            </Label>
                    <Row>
                      {
                        bentukMerchant === 1 ?
                          <Col md="6">
                            <div className="custom-control custom-checkbox mb-3">
                              <Input
                                className="custom-control-input"
                                id="ktp"
                                type="checkbox"
                                value={1}
                                checked={ktp}
                                onChange={(e) => {
                                  let checkedValue = 0;
                                  if (e.target.checked) {
                                    checkedValue = 1;
                                  }
                                  setKtp(checkedValue);
                                }}

                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="ktp"
                              >
                                Fotokopi KTP / Password (WNA)
                                            </Label>
                            </div>
                            <div className="custom-control custom-checkbox mb-3">
                              <Input
                                className="custom-control-input"
                                id="npwp"
                                type="checkbox"
                                checked={npwp}
                                value={1}
                                onChange={(e) => {
                                  let checkedValue = 0;
                                  if (e.target.checked) {
                                    checkedValue = 1;
                                  }
                                  setNpwp(checkedValue);
                                }}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="npwp"
                              >
                                Fotokopi NPWP (Jika ada)
                                            </Label>
                            </div>
                            <div className="custom-control custom-checkbox mb-3">
                              <Input
                                className="custom-control-input"
                                id="pbb"
                                type="checkbox"
                                checked={pbb}
                                value={1}
                                onChange={(e) => {
                                  let checkedValue = 0;
                                  if (e.target.checked) {
                                    checkedValue = 1;
                                  }
                                  setPbb(checkedValue);
                                }}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="pbb"
                              >
                                Fotokopi PBB/Surat Sewa/Surat Domisili (Jika ada)
                                            </Label>
                            </div>
                            <div className="custom-control custom-checkbox mb-3">
                              <Input
                                className="custom-control-input"
                                id="foto"
                                type="checkbox"
                                checked={fotoUsaha}
                                value={1}
                                onChange={(e) => {
                                  let checkedValue = 0;
                                  if (e.target.checked) {
                                    checkedValue = 1;
                                  }
                                  setFotoUsaha(checkedValue);
                                }}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="foto"
                              >
                                Foto Tempat Usaha
                                            </Label>
                            </div>
                          </Col> :
                          <Col md="6">
                            <div className="custom-control custom-checkbox mb-3">
                              <Input
                                className="custom-control-input"
                                id="ktp1"
                                type="checkbox"
                                value={1}
                                checked={ktp}
                                onChange={(e) => {
                                  let checkedValue = 0;
                                  if (e.target.checked) {
                                    checkedValue = 1;
                                  }
                                  setKtp(checkedValue);
                                }}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="ktp1"
                              >
                                Fotokopi KTP / Password (WNA)
                                          </Label>
                            </div>
                            <div className="custom-control custom-checkbox mb-3">
                              <Input
                                className="custom-control-input"
                                id="npwpBadanHukum"
                                type="checkbox"
                                value={1}
                                checked={npwp}
                                onChange={(e) => {
                                  let checkedValue = 0;
                                  if (e.target.checked) {
                                    checkedValue = 1;
                                  }
                                  setNpwp(checkedValue);
                                }}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="npwpBadanHukum"
                              >
                                Fotokopi NPWP Badan Hukum
                                          </Label>
                            </div>
                            <div className="custom-control custom-checkbox mb-3">
                              <Input
                                className="custom-control-input"
                                id="aktaPerusahaan"
                                type="checkbox"
                                value={1}
                                checked={aktaPerusahaan}
                                onChange={(e) => {
                                  let checkedValue = 0;
                                  if (e.target.checked) {
                                    checkedValue = 1;
                                  }
                                  setAktaPerusahaan(checkedValue);
                                }}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="aktaPerusahaan"
                              >
                                Fotokopi Akta Perusahaan
                                          </Label>
                            </div>
                            <div className="custom-control custom-checkbox mb-3">
                              <Input
                                className="custom-control-input"
                                id="kemenkumham"
                                type="checkbox"
                                value={1}
                                checked={suratKemenkumham}
                                onChange={(e) => {
                                  let checkedValue = 0;
                                  if (e.target.checked) {
                                    checkedValue = 1;
                                  }
                                  setSuratKemenkumham(checkedValue);
                                }}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="kemenkumham"
                              >
                                Fotokopi Surat Kemenkumham
                                          </Label>
                            </div>
                            <div className="custom-control custom-checkbox mb-3">
                              <Input
                                className="custom-control-input"
                                id="siup"
                                type="checkbox"
                                value={1}
                                checked={siup}
                                onChange={(e) => {
                                  let checkedValue = 0;
                                  if (e.target.checked) {
                                    checkedValue = 1;
                                  }
                                  setSiup(checkedValue);
                                }}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="siup"
                              >
                                Fotokopi SIUP
                                          </Label>
                            </div>
                            <div className="custom-control custom-checkbox mb-3">
                              <Input
                                className="custom-control-input"
                                id="tdp"
                                type="checkbox"
                                value={1}
                                checked={tdp}
                                onChange={(e) => {
                                  let checkedValue = 0;
                                  if (e.target.checked) {
                                    checkedValue = 1;
                                  }
                                  setTdp(checkedValue);
                                }}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="tdp"
                              >
                                Fotokopi TDP
                                          </Label>
                            </div>
                            <div className="custom-control custom-checkbox mb-3">
                              <Input
                                className="custom-control-input"
                                id="skdu"
                                type="checkbox"
                                value={1}
                                checked={situ}
                                onChange={(e) => {
                                  let checkedValue = 0;
                                  if (e.target.checked) {
                                    checkedValue = 1;
                                  }
                                  setSitu(checkedValue);
                                }}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="skdu"
                              >
                                Fotokopi SITU/SKDU
                                          </Label>
                            </div>
                            <div className="custom-control custom-checkbox mb-3">
                              <Input
                                className="custom-control-input"
                                id="tempatUsaha"
                                type="checkbox"
                                value={1}
                                checked={fotoUsaha}
                                onChange={(e) => {
                                  let checkedValue = 0;
                                  if (e.target.checked) {
                                    checkedValue = 1;
                                  }
                                  setFotoUsaha(checkedValue);
                                }}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="tempatUsaha"
                              >
                                Foto Tempat Usaha
                                          </Label>
                            </div>
                            <div className="custom-control custom-checkbox mb-3">
                              <Input
                                className="custom-control-input"
                                id="suratKuasa"
                                type="checkbox"
                                value={suratKuasa}
                                value={1}
                                checked={suratKuasa}
                                onChange={(e) => {
                                  let checkedValue = 0;
                                  if (e.target.checked) {
                                    checkedValue = 1;
                                  }
                                  setSuratKuasaa(checkedValue);
                                }}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="suratKuasa"
                              >
                                Surat Kuasa (Jika ada)
                                          </Label>
                            </div>
                          </Col>
                      }
                    </Row>
                  </FormGroup>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="exampleFormControlSelect3"
                    >
                      Tanggal Berkas Terkumpul
                            </Label>
                    <Input
                      id="example-date-input"
                      type="date"
                      value={tanggalDoc}
                      invalid={tanggalDocError === "invalid"}
                      onChange={(e) => {
                        setTanggalDoc(e.target.value);
                        if (e.target.value !== "") {
                          setTanggalDocError("");
                        }
                      }}
                    />
                    <FormFeedback>Tanggal Berkas Terkumpul tidak boleh kosong</FormFeedback>
                  </FormGroup>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="exampleFormControlInput1"
                    >
                      Status
                                            </Label>
                    <Input name="status" type="select" value={status}
                      onChange={(e) => {
                        setStatus(e.target.value);
                      }}>
                      <option value="">-- Pilih Status --</option>
                      {
                        statusList.map((stat, key) => {
                          return <option key={key} value={stat.value}>{stat.description}</option>
                        })
                      }
                    </Input>
                  </FormGroup>
                </CardBody>
                <CardFooter>
                  {!isLoading && (<Button color="primary" type="submit">
                    Simpan
                  </Button>)}
                  {isLoading && (<Button color="primary" disabled>
                    <i className="fas fa-spinner fa-spin"></i>{""}
                    Loading...
                  </Button>)}
                  <Link class="btn btn-info" to="/admin/customers/daftar-project">
                    Kembali
                  </Link>
                </CardFooter>
              </Card>
            </Form>
          </div>
        </Row>
      </Container>
    </>
  );
}
